module.exports = __webpack_public_path__ + "static/bg-office-argentina-1c2adbbab17606d79550eef5eb96b67e.png";